/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { useMemo } from "react";
import { useShallow } from "zustand/shallow";

import { EventHandler } from "@rfice/eventhandler";

import useWhiteboardStore from "../stores/useWhiteboardStore";
import useNetworkWhiteboardStore from "../stores/useNetworkWhiteboardStore";
import { ShrinkButtonStyle } from "./emotion";
import { Button, Splitter } from "../designStuff";

export default function ShrinkButton() {
	const { setIsOpen, setWindowState, userId } = useWhiteboardStore(
		useShallow((state) => ({
			setIsOpen: state.setIsOpen,
			setWindowState: state.setWindowState,
			userId: state.userId
		}))
	);

	const ownerInfo = useNetworkWhiteboardStore((state) => state.ownerInfo);

	const isExpand = useMemo(() => ownerInfo == null, [ownerInfo]);
	const isOwner = useMemo(() => ownerInfo != null && ownerInfo.id == userId, [ownerInfo, userId]);
	const canClose = isExpand || isOwner;

	const onClose = () => {
		if (!isOwner) setIsOpen(false);
		EventHandler.fire("$ShrinkButton::Close$");
	};

	return (
		<div css={ShrinkButtonStyle}>
			<div title={"최소화"} style={{ display: "flex" }}>
				<Button name="minimize" onClick={() => setWindowState("minimize")} />
			</div>
			{canClose && (
				<>
					<Splitter />
					<div title={"종료"} style={{ display: "flex" }}>
						<Button name="close" onClick={() => canClose && onClose()} />
					</div>
				</>
			)}
		</div>
	);
}
